export default __webpack_public_path__ + "../staticImages/sprite-paypalexpress-2x.png";